export default [
	{
		name: 'root',
		label: 'Wrapper',
		selector: '&'
	},
	{
		name: 'image',
		label: 'Image',
		selector: '& img'
	},
	{
		name: 'titleAbove',
		label: 'Title Above',
		selector: '& .title-above'
	},
	{
		name: 'body',
		label: 'Body Text',
		selector: '& .body'
	},
	{
		name: 'titleBelow',
		label: 'Title Below',
		selector: '& .title-below'
	}
]